import "filepond-polyfill";

import * as FilePond from 'filepond';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
FilePond.registerPlugin(FilePondPluginFileValidateType);

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.js-uploader').forEach(function (fieldset) {
        var input = fieldset.querySelector('input');

        const pond = FilePond.create(fieldset, {
            allowMultiple: true,
            allowFileTypeValidation: false,
            required: input.getAttribute('required'),
            dropOnPage: false,
            dropOnElement: true,
            credits: false,
            files: JSON.parse(input.getAttribute('data-files')),
            server: {
                process: {
                    url: input.getAttribute('data-endpoint'),
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'Accept': 'application/json'
                    },
                    onerror: (json) => {
                        try {
                            return JSON.parse(json).body;
                        } catch (e) {
                            return null;
                        }
                    }
                },
                fetch: null,
                revert: null
            },
            labelIdle: 'Sleep je bestanden hier of <span class="filepond--label-action">klik hier</span>',
            labelInvalidField: 'Veld bevat ongeldige bestanden',
            labelFileWaitingForSize: 'Wachten op formaat',
            labelFileSizeNotAvailable: 'Formaat is niet beschikbaar',
            labelFileCountSingular: 'Bestand in lijst',
            labelFileCountPlural: 'Bestanden in lijst',
            labelFileLoading: 'Laden',
            labelFileAdded: 'Toegevoegd', // assistive only
            labelFileLoadError: 'Er is iets fout gegaan',
            labelFileRemoved: 'Verwijderd', // assistive only
            labelFileRemoveError: 'Er is iets fout gegaan',
            labelFileProcessing: 'Uploaden',
            labelFileProcessingComplete: 'Upload voltooid',
            labelFileProcessingAborted: 'Upload geanuleerd',
            labelFileProcessingError: (error) => {
                return error.body ? error.body : 'Er is iets fout gegaan';
            },
            labelFileProcessingRevertError: 'Er is iets fout gegaan',

            labelTapToCancel: 'klik om te annuleren',
            labelTapToRetry: 'klik om opnieuw te proberen',
            labelTapToUndo: 'klik om ongedaan te maken',

            labelButtonRemoveItem: 'Verwijder',
            labelButtonAbortItemLoad: 'Abort',
            labelButtonRetryItemLoad: 'Opnieuw',
            labelButtonAbortItemProcessing: 'Annuleren',
            labelButtonUndoItemProcessing: 'Ongedaan maken',
            labelButtonRetryItemProcessing: 'Opnieuw',
            labelButtonProcessItem: 'Upload',
        });

        pond.on('updatefiles', files => {
            window.dispatchEvent(new CustomEvent('uploaded-changed', {detail: {count: files.length}}));
        })

        pond.on('processfiles', files => {
            window.dispatchEvent(new CustomEvent('done-uploading'));
        })
    });
});
